import { styled } from '@mui/material/styles';

export const HeaderContainer = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: 0,
  width: '100%',
  background: theme.palette.common.white,
  zIndex: 1000,
}));

export const HeadContainerInner = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  minHeight: 72,
  padding: '8px 16px',
  fontFamily: theme.typography.fontFamily,
  borderBottom: '1px solid #e0e0e0',
}));

export const LeftSection = styled('div')(() => ({
  position: 'absolute',
  left: 16,
  display: 'flex',
  alignItems: 'center',
}));

export const RightSection = styled('div')(() => ({
  position: 'absolute',
  right: 16,
  display: 'flex',
  alignItems: 'center',
}));

export const HeadDivider = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
}));

export const DriverLogo = styled('span')(() => ({
  display: 'flex',
  justifyContent: 'center',
}));

export const LinearProgressStyled = styled('div')(() => ({
  '& .MuiLinearProgress-root': {
    backgroundColor: '#dddddd',
    height: '6px',
  },
  '& .MuiLinearProgress-bar': {
    backgroundColor: '#0b9a64',
    borderRadius: 8,
  },
}));

export const LogoImage = styled('img')(() => ({
  width: '100%',
  maxWidth: 220,
  maxHeight: 56,
  objectFit: 'contain',
}));
